/**
 * Ressources à débloquer : popup d'inscription (accès email) ou d'achat (accès payant).
 *
 * - Clic sur un lien [data-ressource-acces] : si l'accès est "email" et le visiteur déjà débloqué
 *   (klapi-deblocage.js), le lien s'ouvre normalement ; sinon le popup <dialog> s'ouvre, rempli
 *   avec les attributs data du lien (aperçu, points, produit, prix).
 * - Email : la barre monte à 90 % à l'ouverture, puis à 100 % après l'envoi, les points se défloutent
 *   et l'article s'ouvre. GA4 : popup_inscription_vue, generate_lead (source = article-[handle]).
 * - Payant : "Ajouter au panier" (Ajax API), fermeture du popup, ouverture du tiroir panier.
 *   GA4 : view_item à l'ouverture, add_to_cart au clic.
 * - Fermeture : Échap (natif <dialog>), ✕, clic sur le fond.
 */
(() => {
  if (window.klapiRessource) return;
  window.klapiRessource = true;

  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  const suivre = (evenement, donnees) => window.klapiDeblocage?.suivre(evenement, donnees);
  let lienActif = null;

  const popup = () => document.querySelector('[data-popup-ressource]');

  function remplir(dialog, lien) {
    const d = lien.dataset;
    const payant = d.ressourceAcces === 'payant';
    const points = (() => {
      try {
        return JSON.parse(d.ressourcePoints || '[]') || [];
      } catch (e) {
        return [];
      }
    })();
    const lisibles = payant ? 1 : 2;
    const q = (sel) => dialog.querySelector(sel);

    q('[data-popup-apercu]').textContent = d.ressourceApercu;
    q('[data-popup-points]').replaceChildren(
      ...points.map((texte, i) => {
        const li = document.createElement('li');
        li.innerHTML = '<span aria-hidden="true">✓</span>';
        li.append(texte);
        if (i >= lisibles) {
          li.classList.add('est-floute');
          li.setAttribute('aria-hidden', 'true');
        }
        return li;
      })
    );
    q('[data-popup-surtitre]').textContent = payant ? 'Ressource payante' : 'Réservé aux inscrits';
    q('[data-popup-titre]').textContent = payant ? 'Débloquée à 20 %.' : 'Débloquée à 90 %.';
    q('[data-popup-texte]').textContent = payant
      ? "Le reste coûte moins cher qu'un A/B test raté. Accès immédiat après paiement, et à vie."
      : "Les 10 % restants, c'est votre email. Déjà inscrit ? Le même email suffit, l'article s'ouvre direct.";
    q('[data-popup-etat]').textContent = payant ? 'Aperçu gratuit' : 'Déblocage en cours';
    q('[data-popup-pourcent]').textContent = payant ? '20 %' : '90 %';
    q('[data-popup-note]').textContent = payant
      ? 'Les 80 % restants sont dans la version complète.'
      : 'Il ne manque plus que votre email.';
    q('[data-popup-email]').hidden = payant;
    q('[data-popup-payant]').hidden = !payant;
    dialog.style.setProperty('--progression', payant ? '0.2' : '0.9');

    // Formulaire : tag de source propre à la ressource
    const form = q('[data-deblocage]');
    form.dataset.source = d.ressourceSource;
    form.dataset.ressource = `article-${d.ressourceHandle}`;
    form.querySelector('[name="contact[tags]"]').value = `newsletter,${d.ressourceSource}`;
    form.querySelector('[name="return_to"]').value = `${lien.pathname}?customer_posted=true`;

    if (payant) {
      q('[data-popup-produit]').textContent = d.produitNom;
      q('[data-popup-prix]').textContent = d.produitPrix;
      q('[data-popup-barre-prix]').textContent = d.produitBarre || '';
      q('[data-popup-barre-prix]').hidden = !d.produitBarre;
      q('[data-popup-erreur]').hidden = true;
    }
  }

  function ouvrir(lien) {
    const dialog = popup();
    if (!dialog) return false;
    lienActif = lien;
    remplir(dialog, lien);
    dialog.classList.remove('est-anime', 'est-complet');
    dialog.showModal();
    document.documentElement.setAttribute('scroll-lock', '');
    // La barre part de 0 puis monte (800 ms)
    requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('est-anime')));
    if (lien.dataset.ressourceAcces === 'payant') {
      suivre('view_item', { item_id: lien.dataset.produitVariante, item_name: lien.dataset.produitNom });
    } else {
      suivre('popup_inscription_vue', { source: `article-${lien.dataset.ressourceHandle}` });
    }
    return true;
  }

  function fermer() {
    const dialog = popup();
    if (dialog?.open) dialog.close();
  }

  document.addEventListener('click', (event) => {
    const lien = event.target.closest('a[data-ressource-acces]');
    if (!lien) return;
    const acces = lien.dataset.ressourceAcces;
    if (acces === 'email' && window.klapiDeblocage?.estDebloque()) return;
    if (ouvrir(lien)) event.preventDefault();
  });

  document.addEventListener('click', async (event) => {
    const dialog = popup();
    if (!dialog) return;
    if (event.target === dialog || event.target.closest('[data-popup-fermer]')) {
      fermer();
      return;
    }
    const bouton = event.target.closest('[data-popup-ajouter]');
    if (!bouton || !lienActif) return;
    bouton.setAttribute('aria-busy', 'true');
    try {
      const reponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(lienActif.dataset.produitVariante), quantity: 1 }] }),
      });
      if (!reponse.ok) throw new Error((await reponse.json()).description || "L'ajout au panier a échoué.");
      suivre('add_to_cart', { item_id: lienActif.dataset.produitVariante, item_name: lienActif.dataset.produitNom });
      fermer();
      document.dispatchEvent(new CustomEvent('klapi:panier', { detail: { ouvrir: true } }));
    } catch (e) {
      const erreur = dialog.querySelector('[data-popup-erreur]');
      erreur.textContent = e.message;
      erreur.hidden = false;
    } finally {
      bouton.removeAttribute('aria-busy');
    }
  });

  // Bouton "Ajouter au panier" du bloc de verrou d'un article payant
  document.addEventListener('click', async (event) => {
    const bouton = event.target.closest('[data-ressource-ajout]');
    if (!bouton) return;
    bouton.setAttribute('aria-busy', 'true');
    try {
      const reponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(bouton.dataset.ressourceAjout), quantity: 1 }] }),
      });
      if (reponse.ok) {
        suivre('add_to_cart', { item_id: bouton.dataset.ressourceAjout, item_name: bouton.dataset.produitNom });
        document.dispatchEvent(new CustomEvent('klapi:panier', { detail: { ouvrir: true, declencheur: bouton } }));
      }
    } finally {
      bouton.removeAttribute('aria-busy');
    }
  });

  // Téléchargement d'une ressource
  document.addEventListener('click', (event) => {
    const lien = event.target.closest('[data-telechargement]');
    if (lien) suivre('ressource_telechargee', { ressource: `article-${lien.dataset.telechargement}` });
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches?.('[data-popup-ressource]')) document.documentElement.removeAttribute('scroll-lock');
  }, true);

  // Email envoyé depuis le popup : 100 %, déflouté, puis ouverture de l'article
  document.addEventListener('klapi:debloque', (event) => {
    const dialog = popup();
    if (!dialog?.open || !lienActif || !dialog.contains(event.detail?.form)) return;
    dialog.style.setProperty('--progression', '1');
    dialog.classList.add('est-complet');
    dialog.querySelector('[data-popup-pourcent]').textContent = '100 %';
    const url = lienActif.href;
    setTimeout(() => {
      window.location.href = url;
    }, reduit.matches ? 0 : 900);
  });
})();
